import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.scss']
})
export class EducationComponent implements OnInit {
  timeline = [
    // {
    //   heading: "Infosys",
    //   duration: "Present",
    //   subtitle: "",
    //   content: "Upcoming Full stack develover at Infosys!",
    //   className1: "mar-left",
    //   className2: "prt_about_learnbox_right"
    // },
    {
      heading: "B.Tech - Electronics and communication Engineering",
      duration: "2016",
      subtitle: "BVRIT, Narsapur",
      content: "Successfully completed my B.tech in Electronics and communication Engineering from Padmasri Dr B.V.Raju Institute of Technology.",
      className1: "mar-right",
      className2: "prt_about_learnbox_left"
    },
    {
      heading: "Higher Secondary(12th)",
      duration: "2012",
      subtitle: "SSC Board",
      content: "Successfully completed my intermediate studies in 2012 from Narayana Junior College, S.R.Nagar.\n" +
        "Major: MPC.",
      className1: "mar-left",
      className2: "prt_about_learnbox_right"
    },
    {
      heading: "Secondary Stage(10th)",
      duration: "2010",
      subtitle: "SSC Board",
      content: "Successfully completed my high school studies in 2014 from M.B.Grammar School, Suraram.",
      className1: "mar-right",
      className2: "prt_about_learnbox_left"
    }
    ];

  constructor() { }

  ngOnInit(): void {
  }

}
